exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.reception-conditions__tabs[data-v-46d7ed73] {\n  border-bottom: 0.66px solid #ECECEC;\n  margin-bottom: 8px;\n}\n.reception-conditions__tabs--tab[data-v-46d7ed73] {\n    text-transform: none;\n    color: #848484;\n    font-weight: 500;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/building-monitor/components/bm-conditions/styles.scss"],"names":[],"mappings":";AACE;EACE,oCAAmC;EACnC,mBAAkB;CAOnB;AALC;IACE,qBAAoB;IACpB,eAAc;IACd,iBAAgB;CACjB","file":"styles.scss","sourcesContent":[".reception-conditions {\n  &__tabs {\n    border-bottom: 0.66px solid #ECECEC;\n    margin-bottom: 8px;\n\n    &--tab {\n      text-transform: none;\n      color: #848484;\n      font-weight: 500;\n    }\n  }\n\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46d7ed73","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/building-monitor/components/bm-conditions/styles.scss
// module id = Qzmh
// module chunks = 0